module.exports = __webpack_public_path__ + "media/icons/icons_stars_active_lrg-940ee31d.svg";